import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DepositActions } from 'store/actionCreators';
import UserDepositTemplate from 'components/user/UserDepositTemplate/UserDepositTemplate';
import Circles from 'components/common/Loaders/Circles';

class UserDepositContainer extends Component {
  state = {
    loading: true,
    page: 1,
    limit: 20,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    try {
      await DepositActions.getDepositBalance();
      await DepositActions.getDepositHistory({
        limit: this.state.limit,
        offset: 0,
      });
      this.setState({ loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  };

  handlePageChange = async (page) => {
    const offset = (page - 1) * this.state.limit;
    try {
      await DepositActions.getDepositHistory({
        limit: this.state.limit,
        offset,
      });
      this.setState({ page });
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    const { loading, page, limit } = this.state;
    const { deposit } = this.props;

    if (loading) {
      return <Circles />;
    }

    return (
      <UserDepositTemplate
        balance={deposit.balance}
        history={deposit.history}
        historyCount={deposit.historyCount}
        page={page}
        limit={limit}
        onPageChange={this.handlePageChange}
      />
    );
  }
}

export default connect(
  ({ deposit }) => ({
    deposit,
  }),
  () => ({}),
)(UserDepositContainer);



// WEBPACK FOOTER //
// ./src/containers/user/UserDepositContainer.js